module.exports = __webpack_public_path__ + "static/media/product20.75942868.jpg";